import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NursingStation } from "../../../api";

@Component({
    selector: 'my-nursing-station-page',
    templateUrl: 'nursing-station-page.component.html',
    styleUrls: ['../wizard-page-styles.scss']
})
export class NursingStationPage {
    private _nursingStations: NursingStation[] = [];

    get nursingStations(): NursingStation[] {
        return this._nursingStations;
    }

    @Input('nursingStations')
    set nursingStations(nursingStations: NursingStation[]) {
        this._nursingStations = nursingStations;
        this.selectNursingStation();
    }
    @Output() nursingStationsChange = new EventEmitter<NursingStation>();

    areAllNursingStationsSelected: boolean = false;
    selectedNursingStation: boolean = false;

    constructor() {
        
    }

    selectNursingStation(){
        setTimeout(()=>{
            let selectedNSCount = this._nursingStations.filter(x => x.IsSelected).length;

            if(this.areAllNursingStationsSelected && selectedNSCount === this._nursingStations.length - 1){
                this._nursingStations.forEach(f => f.IsSelected = !f.IsSelected);
                this.areAllNursingStationsSelected = false;
            }else{
                this.selectedNursingStation =  selectedNSCount > 0;
                this.areAllNursingStationsSelected = this._nursingStations.length === selectedNSCount;
            }
        });
    }

    selectAllNursingStations(){
        this._nursingStations.forEach(ns => ns.IsSelected=true);
        this.selectNursingStation();
    }
}